"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pipeFrom = ({ ast, execObject }) => {
    if (ast.children.arguments) {
        const argumentsAst = ast.children.arguments[0];
        return execObject.interpreter({ ast: argumentsAst, execObject });
    }
    else {
        return execObject.interpreter({ ast: ast.children.LogicExpression[0], execObject });
    }
};
